import loadable from '@loadable/component';

import './Profile.css';

export default loadable(() => {
  return import('./Profile.jsx');
});
